module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/31446edc97ac1eb0c3d2af65c0d8432a.svg";